<template>
  <div>
      <v-container fluid class="pl-0 pr-0">
        <div class="BGImg">
          <div>
            <v-row justify="center" class="mb-5" no-gutters>
              <v-col cols="auto">
                <v-card elevation="0" color="transparent">
                  <h1 class="title-font white--text">
                    {{ Title }}
                  </h1>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters justify="center" v-if="Page < 2">
              <v-col cols="auto">
                <v-card :loading="Loading" elevation="0" color="transparent">
                  <v-card-title class="pt-2">
                    <v-form v-model="Validity" ref="CFGForm">
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" xl="2" lg="2">
                          <v-card  class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2" elevation="0">
                            <v-autocomplete
                                prepend-inner-icon="mdi-map-marker-outline"
                                placeholder="Select Park"
                                hide-details
                                :items="ParksList"
                                required
                                :rules="[v => !!v || 'Park is required']"
                                item-text="name"
                                item-value="id"
                                v-model="SelectedPark"
                                outlined>
                            </v-autocomplete>
                          </v-card>
                        </v-col>
                        <v-col cols="12" xl="2" lg="2" md="2">
                          <v-dialog
                              ref="dialog"
                              v-model="DayDialogIn"
                              :return-value.sync="CheckInDate"
                              persistent
                              width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-card class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2" elevation="0">
                                <v-text-field
                                    hide-details
                                    v-model="CheckInDate"
                                    outlined
                                    prepend-inner-icon="mdi-calendar-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </v-card>
                            </template>
                            <v-date-picker
                                v-model="CheckInDate"
                                scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="DayDialogIn = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.dialog.save(CheckInDate)">
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" xl="2" lg="2" md="2">
                          <v-dialog
                              ref="dialogOut"
                              v-model="DayDialogOut"
                              :return-value.sync="CheckOutDate"
                              persistent
                              width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-card class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2" elevation="0">
                                <v-text-field
                                    hide-details
                                    v-model="CheckOutDate"
                                    outlined
                                    prepend-inner-icon="mdi-calendar-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </v-card>
                            </template>
                            <v-date-picker
                                v-model="CheckOutDate"
                                scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="DayDialogOut = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.dialogOut.save(CheckOutDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" xl="2" lg="2">
                          <v-card class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2" elevation="0">
                            <v-select
                                :rules="[v => !!v || 'Number of Guests are required']"
                                prepend-inner-icon="mdi-account-outline"
                                hide-details
                                :items="PeopleList"
                                v-model="SelectedPeople"
                                placeholder="Select No of People"
                                outlined>
                            </v-select>
                          </v-card>
                        </v-col>
                        <v-col class="mb-4" cols="auto" xl="2" lg="2">
                          <v-btn @click="getPackagesLocal" block height="56" dark color="#D6AF44" width="100%">
                            <div class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2">
                            Book Now
                            </div>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-container>
      <v-container>
      <v-row no-gutters>
        <v-col class="mt-16">
          <v-card :loading="Loading" color="transparent" elevation="0">
            <v-row justify="center" no-gutters v-if="Page < 2 && PackagesList.length > 0">
              <Flicking @changed="OnTheFlickingMove" ref="flicking" :options="flickingOptions" :plugins="plugins">
                <PlanCard @OnPlanSelect="OnPlanSelect"
                          :plan="plan"
                          @nextpage="Page++"
                          @backpage="Page--"
                          @move="OnPlanFocus"
                          :total="MoneyFormat(Total)"
                          :selected-package="SelectedPackage"
                          :page="Page"
                          v-for="(plan,i) in PackagesList" :key="i"></PlanCard>
                <span @click="LeftClick" ref="LeftArrow"  style="top: 25%" slot="viewport" class="flicking-arrow-prev"></span>
                <span @click="RightClick" ref="RightArrow" style="top: 25%" slot="viewport" class="flicking-arrow-next"></span>
              </Flicking>

            </v-row>

            <v-row justify="center" no-gutters v-if="!Loading && PackagesList.length === 0">
              <v-alert color="red" dark>
                Currently we are not operating in this park!
              </v-alert>
            </v-row>

            <div ref="AddonsElement"></div>

            <v-card-title v-if="Page === 1">
              <v-col cols="12">
                <h1 class="mt-10 title-font">Add-ons</h1>
                <p class="ThemeFont text-center SmallFont pl-4 pr-4">
                  Customize your package with special services that we provide.
                </p>
              </v-col>

              <v-row justify="center" no-gutters class="addon-group">
                <AddonCard
                    @OnAddonSelect="OnAddonSelect"
                    @OnAddonIncrement="addon.quantity++"
                    @OnAddonDecrement="addon.quantity--"
                    :addon="addon"
                    :index="i"
                    :selected-addons="SelectedAddons"
                    :key="i" v-for="(addon,i) in AddonsList"/>
              </v-row>

            </v-card-title>

            <v-card-title v-if="Page === 2">
              <v-row no-gutters justify="center">
                <v-col cols="12" xl="6" lg="8" md="10">
                  <SummaryCard :days="[CheckInDate, CheckOutDate]" :park="SummaryPark" :people="SelectedPeople" :pkg="Summary"
                               :addons="SelectedAddons"/>
                  <v-card dark elevation="0" class="mt-n1 rounded-t-0" color="primary">
                    <v-container>
                      <v-row align="center" justify="space-between" no-gutters>
                      <span class="text--white text-h5">Total<span class="font-weight-black ml-4">
                        {{ MoneyFormat(Total) }}
                      </span></span>
                        <v-col cols="auto">
                          <v-btn v-if="Page < 4 && Page > 0" @click="Page--" outlined class="mr-2" width="128"
                                 height="56"
                                 color="white" light>Back
                          </v-btn>
                          <v-btn class="font-weight-bold" v-if="Page < 3" @click="Page++" width="128" height="56"
                                 color="#D6AF44" light>
                            Continue
                          </v-btn>
                        </v-col>

                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-title v-if="Page === 3">
              <v-row justify="center" no-gutters>
                <v-col cols="12" xl="6" lg="7" md="8">
                  <SubmitBooking
                      :package="SelectedPackage"
                      :park="SelectedPark"
                      :addons="SelectedAddons"
                      :cindate="CheckInDate"
                      :coutdate="CheckOutDate"
                      :pax="SelectedPeople"
                      :packagetitle="getSelectedPackageTitle"
                      :parktitle="getSelectedParkTitle"
                      @SaveInvoice="SaveInvoice"
                      @Back="Page--" @Forward="Page++" :total="Total"/>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-title v-if="Page === 4">
              <v-row justify="center" no-gutters>
                <v-col cols="12" xl="6" lg="8" md="10">
                  <InvoiceCard :invoice="InvoiceData" :days="[CheckInDate, CheckOutDate]" :park="SummaryPark" :people="SelectedPeople" :pkg="Summary"
                               :addons="SelectedAddons"/>
                  <v-card dark elevation="0" class="mt-n1 rounded-t-0" color="primary">
                    <v-container>
                      <v-row align="center" justify="space-between" no-gutters>
                      <span class="text--white text-h5">Total<span class="font-weight-black ml-4">
                        {{ MoneyFormat(Total) }}
                      </span></span>


                        <v-col cols="auto">
                          <v-btn class="font-weight-bold" to="/" width="128" height="56" color="#D6AF44" light>
                            OK
                          </v-btn>
                        </v-col>

                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>


    <div v-if="Page > 0 && Page < 2 && PackagesList.length > 0" class="Floater">
      <v-card dark elevation="8" class="ml-2 ml-md-16 ml-lg-16 ml-xl-16 mr-4 mr-md-16 mr-lg-16 mr-xl-16"
              color="#072B23">
        <v-container>
          <v-row align="center" justify="space-between" no-gutters>
            <v-col>
              <div v-if="!Loading" class="text--white text-start text-h5">Total</div>

              <div class="font-weight-black text--white text-start text-h5">
                {{ MoneyFormat(Total) }}
              </div>
            </v-col>


            <v-col cols="auto">
              <v-btn v-if="Page < 4 && Page > 0" @click="Page--" outlined class="mr-2" width="128" height="56"
                     color="white" light>Back
              </v-btn>
              <v-btn class="font-weight-bold" v-if="Page < 3" @click="Page++" width="128" height="56" color="#D6AF44"
                     light>
                Continue
              </v-btn>
            </v-col>

          </v-row>
        </v-container>
      </v-card>
    </div>

  </div>
</template>

<script>
import { Flicking } from "@egjs/vue-flicking";
import '@egjs/vue-flicking/dist/flicking.css';

import { Arrow } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";

import PlanCard from "@/components/PlanCard";
import AddonCard from "@/components/AddonCard";
import axios from "axios";
import SummaryCard from "@/components/SummaryCard";
import SubmitBooking from "@/components/SubmitBooking";
import InvoiceCard from "@/components/InvoiceCard";


export default {
  name: 'Packages',
  components: { Flicking, InvoiceCard, SubmitBooking, SummaryCard, AddonCard, PlanCard},
  computed: {
    getSelectedParkTitle() {
      return this.ParksList.find(element => element.id === this.SelectedPark).name;
    },
    getSelectedPackageTitle() {
      return this.PackagesList.find(element => element.id === this.SelectedPackage).name;
    },
    Title() {
      if (this.Page === 0 || this.Page === 1) {
        return 'PACKAGES'
      } else if (this.Page === 2) {
        return 'BOOKING SUMMARY'
      } else if (this.Page === 3) {
        return 'COMPLETE YOUR BOOKING'
      } else {
        return 'THANK YOU FOR BOOKING!'
      }
    },
    Total: function () {
      if (this.PackagesList.length > 0) {
        let total = this.SelectedPeople;
        let Package = this.PackagesList.find(el => el.id === this.SelectedPackage);

        let cIn = new Date(this.CheckInDate);
        let cOut = new Date(this.CheckOutDate);

        let days = (cOut.getTime() - cIn.getTime()) / (1000 * 60 * 60 * 24);


        total = Package.package_details[0].price * total * days;

        this.SelectedAddons.forEach(value => {
          if (value.type === 0) {
            total += this.SelectedPeople * value.price;
          } else {
            total += value.price;
          }
        });
        return total;
      } else {
        return 0.00;
      }
    },
    Summary() {
      return this.PackagesList.find(element => element.id === this.SelectedPackage);
    },
    SummaryPark() {
      return this.ParksList.find(element => element.id === this.SelectedPark);
    },
  },
  data: () => ({
    flickingOptions: {
      align: 'center',
      circular: false,
      adaptive: false,
      duration: 300,
      defaultIndex: 0,
      resizeOnContentsReady: false
    },
    plugins: [new Arrow({ parentEl: document.body })],
    Page: 0,
    Validity: false,
    DayDialogIn: false,
    DayDialogOut: false,
    DayDialog: false,
    Loading: true,
    ParksList: [],
    PeopleList: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    PackagesList: [],
    AddonsList: [],
    SelectedPark: null,
    SelectedPeople: 4,
    SelectedDay: [],
    CheckInDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    CheckOutDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    SelectedPackage: 0,
    SelectedAddons: [],
    InvoiceData:{},
  }),
  methods: {
    OnTheFlickingMove(e) {
      console.log(e);
      //let indexOfCurrentPlan = this.PackagesList.findIndex(el => el.id === this.SelectedPackage);
      let idOfJumpedPlan = this.PackagesList[e.index].id;
      this.OnPlanSelect(idOfJumpedPlan);
    },
    LeftClick(){
      let indexOfCurrentPlan = this.PackagesList.findIndex(el => el.id === this.SelectedPackage);
      let idOfNextPlan = this.PackagesList[indexOfCurrentPlan - 1].id;
      console.log(indexOfCurrentPlan);
      console.log(idOfNextPlan);
      this.OnPlanSelect(idOfNextPlan);
    },

    RightClick(){
      let indexOfCurrentPlan = this.PackagesList.findIndex(el => el.id === this.SelectedPackage);
      let idOfNextPlan = this.PackagesList[indexOfCurrentPlan + 1].id;
      console.log(indexOfCurrentPlan);
      console.log(idOfNextPlan);
      this.OnPlanSelect(idOfNextPlan);
    },

    SaveInvoice(data) {
      this.InvoiceData = data;
    },
    MoneyFormat(value) {
      return Intl.NumberFormat('en-US', {style: 'currency', currency: 'LKR'}).format(value);
    },
    OnPlanFocus(panel) {
      console.log(panel);
    },
    OnPlanSelect(id) {
      this.SelectedPackage = id;
      this.SelectedAddons = [];
      let pkg_addons = this.PackagesList.find(element => element.id === id).addons;
      pkg_addons = pkg_addons.map(v => ({...v, quantity: 1}));
      console.log(pkg_addons);
      this.AddonsList = pkg_addons;
      if(this.$refs.flicking !== undefined) {
        this.$refs.flicking.moveTo(this.PackagesList.indexOf(this.PackagesList.find(element => element.id === id)));
      }
    },
    OnAddonSelect(addon) {
      console.log(this.SelectedAddons.indexOf(addon));
      if (this.SelectedAddons.indexOf(addon) === -1) {
        this.SelectedAddons.push(addon);
      } else {
        this.SelectedAddons.splice(this.SelectedAddons.indexOf(addon), 1);
      }
    },

    getParks() {
      axios.get('https://admin.wca.innocube.lk/api/park').then(value => {
        console.log(value.data.data);
        this.ParksList = value.data.data;
        this.setConfigs();
      });
    },
    setConfigs() {
      this.SelectedPark = this.$route.params['SelectedPark'];
      this.SelectedPeople = this.$route.params['SelectedPeople'];
      if (this.$route.params['SelectedDay'] !== undefined) {
        this.CheckInDate = this.$route.params['SelectedDay'][0];
        this.CheckOutDate = this.$route.params['SelectedDay'][1];
      }
      this.getPackages();
    },
    getPackages() {

      //console.log(this.Validity);
      this.Loading = true;
      axios.post('https://admin.wca.innocube.lk/api/searched-packages', {
        "park_id": this.SelectedPark,
        "pax": this.SelectedPeople
      }).then(value => {
        if (value.data.length > 0) {
          let middle = Math.round(value.data.length / 2);
          this.flickingOptions.defaultIndex = middle;
          this.PackagesList = value.data;
          this.OnPlanSelect(this.PackagesList[middle].id);
          console.log(middle);
        }
        this.Loading = false;
      });
    },

    getPackagesLocal() {
      this.$refs.CFGForm.validate();
      console.log(this.Validity);
      if (this.Validity) {
        this.Loading = true;
        axios.post('https://admin.wca.innocube.lk/api/searched-packages', {
          "park_id": this.SelectedPark,
          "pax": this.SelectedPeople
        }).then(value => {
          if (value.data.length > 0) {
            let middle = Math.round(value.data.length / 2);
            this.flickingOptions.defaultIndex = middle;
            this.PackagesList = value.data;
            this.OnPlanSelect(this.PackagesList[middle].id);
            console.log(middle);
          }
          this.Loading = false;
        });
      }
    },

  },
  mounted() {
    this.getParks();
  },
  watch: {
    Page(val) {
      this.$nextTick(function () {
        if (val === 1) {
          let element = this.$refs.AddonsElement;
          let top = element.offsetTop + 128;
          window.scrollTo(0, top)
        }
      });
    },
    SelectedPark: function (val) {
      console.log(val);
      this.getPackagesLocal();
    },
    SelectedPeople: function (val) {
      console.log(val);
      this.getPackagesLocal();
    },
    SelectedDay: function (val) {
      console.log(val);
      this.getPackagesLocal();
    },
  }
}
</script>

<style scoped>
.topMargin{
  margin-top: 128px;
}


.Floater {
  position: fixed;
  bottom: 16px;
  width: 100%;
  z-index: 7;
}

.MarginBottom {
  margin-bottom: 128px;
}

.PatuaFont {
  font-family: 'Patua One', serif !important;
}

.SmallFont {
  font-size: 14px;
}

.BGImg {
    width: 100%;
    height: 45vh;
    background-image: url(/assets/packages_bg.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
}

.addon-group {
  padding-bottom: 100px;
}
</style>
